import React, { Fragment } from "react";
import { Row, Col } from "react-bootstrap";
import { Currency } from "../lib/components/Currency";
import { WithApiAccess } from "../lib/HigherOrderComponents/WithApiAccess";
import { LoadingSpinner } from "../lib/components/LoadingSpinner";
import { FormattedDate } from "../lib/components/FormattedDate";
import { Address } from "../lib/components/Address";
import { withHeaderMessages } from "../higherOrderComponents/WithHeaderMessages";

const ConfirmationReceiptGenericPrint = (props) => {
  const { contract, downPayment, fundingOptions } = props;
  if (!contract || downPayment === null || !fundingOptions) {
    return <LoadingSpinner />;
  }

  const recipient =
    contract.recipients.length > 0
      ? contract.recipients[0]
      : {
          firstName: "",
          lastName: "",
          address: {},
        };

  return (
    <>
      <Row>
        <Col xs={12} style={{ textAlign: "center" }}>
          <img
            src="/images/confirmation_receipt.png"
            alt="Clearpoint Trust Confirmation Receipt Header Logo"
            className="confirmation-img"
          />
        </Col>
      </Row>
      <Row>
        <Col xs={6}>
          <Row className="confirmation-row">
            <Col>
              <label>Funeral Provider:</label>
              <div>
                {contract.provider.name}
                <br />
                <Address address={contract.provider.address} />
              </div>
            </Col>
          </Row>
          <Row className="confirmation-row">
            <Col>
              <label>Funeral Recipient:</label>
              <div>
                {recipient.firstName} {recipient.lastName}
                <br />
                <Address address={recipient.address} />
              </div>
            </Col>
          </Row>
          <Row className="confirmation-row">
            <Col>
              <label>Funeral Purchaser:</label>
              <div>
                {contract.purchaser.firstName} {contract.purchaser.lastName}
                <br />
                <Address address={contract.purchaser.address} />
              </div>
            </Col>
          </Row>
        </Col>
        <Col xs={6}>
          <Row className="confirmation-row2" style={{ marginTop: ".25in" }}>
            <Col>
              <label>ClearPoint Contract Number:</label> {contract.number}
            </Col>
          </Row>
          <Row className="confirmation-row-col2">
            <Col>
              <label>Customer Ref Number:</label> {contract.providerNumber}
            </Col>
          </Row>
          <Row className="confirmation-row-col2">
            <Col>
              <label>Amount Received:</label> <Currency amount={downPayment} />
            </Col>
          </Row>
          <Row className="confirmation-row-col2">
            <Col>
              <label>Date Accepted:</label>{" "}
              <FormattedDate date={contract.accepted} format="MMMM D, YYYY" />
            </Col>
          </Row>
          <Row className="confirmation-row-col2">
            <Col>
              <label>Payment Plan:</label>{" "}
              {(contract.numberOfPayments || 0) > 0 ? "Multipay" : "Single Pay"}
            </Col>
          </Row>
          <Row className="confirmation-row-col2">
            <Col>
              <label>Funding Option(s):</label>
              {fundingOptions.map((f, i) => (
                <div key={i}>
                  {f}
                  <br />
                </div>
              ))}
            </Col>
          </Row>
        </Col>
      </Row>
      <Row style={{ marginBottom: "0", marginTop: ".25in" }}>
        <Col xs={12}>
          <img
            src="/images/ClearPoint_Confirmation_Receipt_center_2026.png"
            alt="center rule"
            className="confirmation-img"
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Row className="confirmation-row">
            <p>
              This document is intended as a convenience to our customers and is
              not to be construed as a part of the trust contract. If this
              information differs in any way from the Funeral Planning Trust
              Agreement or Trust Funding Option Form, please call us immediately
              at 1-800-763-0234.
            </p>
            <p>
              This portion must be completed by the funeral provider at the time
              of death and sent to Customer Service via fax at 1-866-208-1236 or
              e-mail at customer.service@clearpointfederal.com.
            </p>
          </Row>
        </Col>
      </Row>
      <Row className="confirmation-row">
        <Col xs={12} className="generic-col-label">
          <label>ClearPoint Contract Number:</label>&nbsp;&nbsp;&nbsp;&nbsp;
          {contract.number}
        </Col>
      </Row>
      <Row className="confirmation-row">
        <Col xs={3} className="generic-col-label">
          <label>Date of Death:</label>
        </Col>
        <Col xs={5} className="ps-0">
          <Row className="signature">&nbsp;</Row>
        </Col>
      </Row>
      <Row className="confirmation-row">
        <Col xs={3} className="generic-col-label">
          <label>At Need Number:</label>
        </Col>
        <Col xs={5} className="ps-0">
          <Row className="signature">&nbsp;</Row>
        </Col>
      </Row>
      <Row className="confirmation-row">
        <Col xs={12}>
          <Row>
            <p>
              The individuals signing below (Signatories") hereby certify that
              all information provided above is true to the best of their
              knowledge and that the agreed upon funeral goods and services were
              furnished. In addition, the Signatories hereby attest that the
              Funeral Recipient named above has died on the date given. The
              Signatories further understand and agree that ClearPoint Trust
              reserves the right to request more information.
            </p>
          </Row>
        </Col>
      </Row>
      <Row className="confirmation-row">
        <Col xs={4} className="generic-col-label">
          <Row>
            <label>Signature of Authorized Funeral Firm Representative:</label>
          </Row>
        </Col>
        <Col xs={5}>
          <Row className="signature">&nbsp;</Row>
        </Col>
        <Col xs={1}>
          <Row className="text-end">
            <label>Date:</label>
          </Row>
        </Col>
        <Col xs={2}>
          <Row className="signature">&nbsp;</Row>
        </Col>
      </Row>
      <Row className="confirmation-row">
        <Col xs={4} className="generic-col-label">
          <Row>
            <label>Print Name:</label>
          </Row>
        </Col>
        <Col xs={5}>
          <Row className="signature">&nbsp;</Row>
        </Col>
      </Row>
      <Row className="confirmation-row">
        <Col xs={4} className="generic-col-label">
          <Row>
            <label>Signature of Legal Representative:</label>
          </Row>
        </Col>
        <Col xs={5}>
          <Row className="signature">&nbsp;</Row>
        </Col>
        <Col xs={1}>
          <Row className="text-end">
            <label>Date:</label>
          </Row>
        </Col>
        <Col xs={2}>
          <Row className="signature">&nbsp;</Row>
        </Col>
      </Row>
      <Row className="confirmation-row">
        <Col xs={4} className="generic-col-label">
          <Row>
            <label>Relationship to Recipient:</label>
          </Row>
        </Col>
        <Col xs={5}>
          <Row className="signature">&nbsp;</Row>
        </Col>
      </Row>
      <Row style={{ marginTop: ".25in" }}>
        <Col xs={12}>
          <img
            src="/images/ClearPoint_Confirmation_Receipt_footer_2026.png"
            alt="footer"
            className="confirmation-img"
          />
        </Col>
      </Row>
    </>
  );
};

export default withHeaderMessages(
  WithApiAccess(ConfirmationReceiptGenericPrint),
);
